import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Warning } from "@phosphor-icons/react";

/**
 * Reusable confirmation dialog for destructive actions.
 * Usage:
 *   <ConfirmDialog open={..} onOpenChange={..} onConfirm={..} title="..." description="..." confirmLabel="Supprimer" />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  title = "Confirmer",
  description = "",
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  destructive = true,
  loading = false,
  testid = "confirm-dialog",
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm bg-[#111] border-white/10 text-white rounded-2xl" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-display text-lg flex items-center gap-2">
            <Warning size={18} className={destructive ? "text-red-400" : "text-amber-400"} weight="duotone" />
            {title}
          </DialogTitle>
          {description && (
            <DialogDescription className="text-sm text-white/70 mt-1">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="flex gap-2 mt-3">
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className="flex-1 border border-white/10 hover:bg-white/5"
            data-testid={`${testid}-cancel`}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 ${destructive ? "bg-red-500 hover:bg-red-600" : "bg-[#005CFF] hover:bg-[#0047CC]"} text-white`}
            data-testid={`${testid}-confirm`}
          >
            {loading ? "…" : confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
